/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { KTIcon } from '../../../../_metronic/helpers'
import { Dropdown1 } from '../../../../_metronic/partials'
import { NotificationApi } from '../../../api'
// import {KTIcon} from '../../../helpers'
// import {Dropdown1} from '../../content/dropdown/Dropdown1'

type Props = {
  className: string
}

const NotificationCard: React.FC<any> = ({props,className}) => {
  const payload = useRef<any>({});
  
  // const { isNotificationClicked, setIsNotificationClicked } = props;
  const [notification, setNotifications] = useState<any>([]);

  useEffect(() => {
      handlePayload();
      fetchNotification();
  }, []);

  const fetchNotification = () => {
      NotificationApi.list(payload.current)
          .then((response) => {
              setNotifications(response.data.results);
          })
          .catch((error) => {
              console.error('Error fetching user data:', error);
          });
  };

  const handlePayload = (): void => {
      payload.current = {
          '$select': '',
          '$search': '',
          '$filter': "notification_channel='Push'",
          '$queryParams': '',
          '$expand': '',
          '$orderby': 'id desc',
          '$top': 6,
          '$skip': 0,
      };
  };

  return (
    <div className='card card-xl-stretch mb-5 mb-xl-8'>
      {/* begin::Header */}
      <div className='card-header border-0'>
        <h3 className='card-title fw-bold text-dark'>Notifications</h3>
        <div className='card-toolbar'>
          {/* begin::Menu */}
          {/* <button
            type='button'
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTIcon iconName='category' className='fs-2' />
          </button>
          <Dropdown1 /> */}
          {/* end::Menu */}
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body pt-0'>
        {/* begin::Item */}
        {notification && notification.map((item: any, index: number) => (
          <div className={`d-flex align-items-center bg-light-${item.notification_type == 1 ? 'success' : item.notification_type == 2 ? 'danger' : 'secondary'} rounded p-5 mb-7`}>
            <span className={` text-${item.notification_type == 1 ? 'success' : item.notification_type == 2 ? 'danger' : 'secondary'} me-5`}>
              <KTIcon iconName='abstract-26' className={`text-${item.notification_type == 1 ? 'success' : item.notification_type == 2 ? 'danger' : 'secondary'} fs-1 me-5`} />
            </span>
            <div className='flex-grow-1 me-2'>
              <a href='#' className='fw-bold text-gray-800 text-hover-primary fs-6'>
                {item.title}
              </a>
              <span className='text-muted fw-semibold d-block fs-8'>
                {item.description}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export {NotificationCard}
